<script>
  import curd from './Base/Crud'
  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'添加新品', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '新品标题',
              prop: 'title',
              overHidden: true,
              span: 24,
              rules: [{
                type: 'string', required: true, message: '输入不正确', trigger: 'blur'
              }]
            }, {
              label: '新品内容',
              prop: 'content',
              overHidden: true,
              type: 'textarea',
              span: 24,
              rules: [{
                type: 'string', required: true, message: '输入不正确', trigger: 'blur'
              }]
            },
            {
              label: '新品日期',
              prop: 'new_time',
              type: 'daterange',
              rules: [{
                required: true, message: '调查日期不能为空', trigger: 'blur'
              }],
              valueFormat: 'yyyy-MM-dd',
              formatter: function (raw) {
                return raw.start_time + '——' + raw.end_time
              }
            },
            {
              label: '新品图片',
              prop: 'filepaths',
              dataType: 'string', // 单图不要此属性
              type: 'upload',
              hide: true,
              // listType: 'picture-img', // 单图
              listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24
            },
          ]
        }
      }
    }
  }
</script>
